'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.installSentry = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

exports.createMiddleware = createMiddleware;
exports.captureError = captureError;

var _user = require('../redux/modules/user');

var _ravenForRedux = require('raven-for-redux');

var _ravenForRedux2 = _interopRequireDefault(_ravenForRedux);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SENTRY_DSN = 'https://fa7392f08ad44440a81d103b44e5b2aa@sentry.io/203557';
var ignoreErrors = [
// Random plugins/extensions
'top.GLOBALS',
// See: http://blog.errorception.com/2012/03/tale-of-unfindable-js-error.html
'originalCreateNotification', 'canvas.contentDocument', 'MyApp_RemoveAllHighlights', 'http://tt.epicplay.com', 'Can\'t find variable: ZiteReader', 'jigsaw is not defined', 'ComboSearch is not defined', 'http://loading.retry.widdit.com/', 'atomicFindClose', 'fb_xd_fragment', 'fb_getSelectionScriptMessageHandle', 'focusHelper',
// ISP "optimizing" proxy - `Cache-Control: no-transform` seems to reduce this. (thanks @acdha)
// See http://stackoverflow.com/questions/4113268/how-to-stop-javascript-injection-from-vodafone-proxy
'bmi_SafeAddOnload', 'EBCallBackMessageReceived',
// See http://toolbar.conduit.com/Developer/HtmlAndGadget/Methods/JSInjection.aspx
'conduitPage'];

var installSentry = exports.installSentry = function installSentry(_ref) {
    var _ref$release = _ref.release,
        release = _ref$release === undefined ? 'LOCALDEV' : _ref$release,
        _ref$environment = _ref.environment,
        environment = _ref$environment === undefined ? 'preprod' : _ref$environment;

    /* eslint-disable no-undef */
    if (typeof Raven === 'undefined') {
        console.info('Raven API not found.');
        return;
    }

    Raven.config(SENTRY_DSN, {
        captureUnhandledRejections: false,
        debug: release === 'LOCALDEV',
        environment: environment,
        ignoreErrors: ignoreErrors,
        ignoreUrls: [/extensions\//i, /^chrome:\/\//i],
        release: release,
        sanitizeKeys: [/token/, /password/i]
    });
    /* eslint-enable no-undef */
};

function createMiddleware() {
    /* eslint-disable no-undef */
    if (typeof Raven === 'undefined') {
        console.info('Raven API not found.');
        return;
    }

    return (0, _ravenForRedux2.default)(Raven, {
        actionTransformer: actionTransformer,
        breadcrumbDataFromAction: breadcrumbDataFromAction,
        getTags: getTags,
        getUserContext: getUserContext,
        stateTransformer: stateTransformer
    });
    /* eslint-disable no-undef */
}

function captureError(error, errorInfo) {
    Raven.captureException(error, {
        extra: { extra: errorInfo }
    });
}

function breadcrumbDataFromAction(_ref2) {
    var payload = _ref2.payload,
        type = _ref2.type;

    if (type.includes('REQUEST')) {
        return { payload: (0, _stringify2.default)(payload) };
    }
}

function actionTransformer(_ref3) {
    var payload = _ref3.payload,
        type = _ref3.type;

    if (type.includes('REQUEST')) {
        return { payload: payload, type: type };
    }

    return { type: type };
}

function getTags(state) {
    var tags = {
        errorType: 'Client Side 500'
    };

    if ((0, _user.isUserLoggedIn)(state)) {
        tags['Logged In'] = true;
        tags['High NMS'] = ((0, _user.getUserData)(state) || {}).ANMS >= 5000;
    } else {
        tags['Logged In'] = false;
    }

    if (window.FS && window.FS.getCurrentSessionURL) {
        tags['FullStory'] = window.FS.getCurrentSessionURL();
    }

    return tags;
}

function getUserContext(state) {
    return {
        bidderId: (0, _user.getBidderId)(state),
        email: (0, _user.getBidderEmail)(state)
    };
}

function stateTransformer(state) {
    var userData = (0, _user.userDataSelector)(state);
    if ((0, _user.isUserLoggedIn)(state) && userData) {
        return (0, _extends3.default)({}, userData, {
            address: 'REDACTED',
            address2: 'REDACTED',
            mobileNumber: 'REDACTED',
            phoneNumber: 'REDACTED'
        });
    }

    return {};
}


//////////////////
// WEBPACK FOOTER
// ./src/utils/sentry.js
// module id = bYhl
// module chunks = 60